import { usePlanRoutes } from './usePlanRoutes';
import { useRoutesWithTasks } from './useRoutesWithTasks';

export function usePlanRoutesWithTasks() {
    const planRoutes = usePlanRoutes();
    return useRoutesWithTasks(planRoutes);
}
